import { SkeletonInfo } from './styles'

export const SkeletonValue = () => <SkeletonInfo />
